import clsx from 'clsx';
import React from 'react';
import { Corner, Shadow } from '../../utils/utils';
import uiConfig from "../../data/uiConfig"
import { useInViewAnimation } from '../../hooks/useInViewAnimation';

interface CardProps {
  children?: React.ReactNode;
  p?: string;
  corner?: Corner;
  shadow?: Shadow;
  bgColor?: string;
  borderColor?: string;
  animation?: 'scroll' | 'flip' | 'zoom' | undefined
  index?: number;
  delay?: number;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  children,
  p = "p-4",
  corner = uiConfig.card.corner as Corner,
  shadow = uiConfig.card.shadow as Shadow,
  bgColor = uiConfig.card.bgColor,
  borderColor = uiConfig.card.borderColor,
  animation,
  index,
  delay = 100,
  className,
}) => {
  const { ref, isVisible } = useInViewAnimation();

  let animationClass = "";
  if (animation == 'scroll') 
    animationClass = "animate-div-up";
  if (animation == 'flip')
    animationClass = "animate-div-flip";
  if (animation == 'zoom')
    animationClass = "animate-div-zoom";

  let delayStyle = "";
  if(index != undefined)
    delayStyle = `${index * delay}ms`;

  return (
    <div
      ref={ref}
      className={
        clsx(p, 
          animation && "opacity-0 transform",
          bgColor,
          corner,
          shadow,
          borderColor && `border ${borderColor}`,
          animation && isVisible && animationClass,
          className
        )}
        style={{ animationDelay: delayStyle }}>
      {children}
    </div>
  )
};